import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage,
    showWarningMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject,
    showWarningMessage,
   API_URL,
};

export const GET_MASTERTHERAPY = `${API_URL}/api/MasterTherapy/GetMasterTherapy`;
export const POST_MASTERTHERAPY = `${API_URL}/api/MasterTherapy/SaveMasterTherapy`;
export const GET_MASTERTHERAPY_BY_ID = `${API_URL}/api/MasterTherapy/GetMasterTherapyById`;
export const DELETE_MASTERTHERAPY = `${API_URL}/api/MasterTherapy/DeleteMasterTherapy`;

export const masterTherapyActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'),
  get_master_therapy: createRequestActionTypes('GET_MASTERTHERAPY'),
  post_master_therapy: createRequestActionTypes('POST_MASTERTHERAPY'),
  get_master_therapy_by_id: createRequestActionTypes('GET_MASTERTHERAPY_BY_ID'),
  delete_master_therapy: createRequestActionTypes('DELETE_MASTERTHERAPY'),
};

export const MODULE = 'MASTER_THERAPY';





// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterTherapy/constants/ApiConstants.js